// src/layout/AppShell.jsx
import React from "react";

export function AppShell({ header, nav, footer, children }) {
  return (
    <div className="appShell">
      <div className="appHeader">{header}</div>
      <div className="appNav">{nav}</div>

      <main className="appMain">{children}</main>

      <div className="appFooter">{footer}</div>
    </div>
  );
}
